import { Injectable } from '@angular/core';
import { CandidateResultDto } from "@shared/clients/api.generated";
import { TopCandidates } from "@shared/components/top-candidates/top-candidates.component";

@Injectable({
  providedIn: 'root'
})
export class TopCandidatesService {

  fromCandidateResults(result: CandidateResultDto[]): TopCandidates[] {
    const highestVoteCandidate = result && result.length > 0 ? result[0].numberOfVotes : null;
    return result.map((candidate) => {
      return {
        name: candidate.displayName,
        votes: candidate.numberOfVotes,
        percentage: highestVoteCandidate && highestVoteCandidate !== 0
          ? (candidate.numberOfVotes! / highestVoteCandidate) * 100 : 0
      }
    });
  }
}
